import { EventStream, SceneObject } from '@cgs/wge';
import { ISlotController } from './base_slot_controller';

export interface ISlotPopupView extends ISlotView {
  popupId: string | null;
  shown: EventStream<void>;
  closed: EventStream<void>;
  closing: EventStream<void>;
  showing: EventStream<void>;
  hide(): void;
}

export interface ISlotView {
  initController(controller: ISlotController): void;
}

export abstract class BaseSlotView<T> implements ISlotView {
  protected _root: SceneObject;
  private _controller: T;

  protected constructor(root: SceneObject) {
    this._root = root;
  }

  public get controller(): T {
    return this._controller;
  }

  public set controller(value: T) {
    this._controller = value;
  }

  public initController(cont: ISlotController): void {
    this._controller = cont as T;
  }

  public get root(): SceneObject {
    return this._root;
  }

  public set root(value: SceneObject) {
    this._root = value;
  }
}
